import React from 'react';
import classNames from './style.module.scss';

interface PDFDownloadProps {
	documentLabel: string;
	documentSource: string;
}

const PDFDownload: React.FC<PDFDownloadProps> = (props) => {
	return (
		<a
			className={classNames.pdfDownload}
			href={props.documentSource}
			download={props.documentLabel}
			target="_blank"
			rel="noopener noreferrer"
		>
			<i className="bi bi-file-text"></i>
			Download {props.documentLabel}
		</a>
	);
};

export default PDFDownload;
